import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installCrashOverlay, showCrashOverlay } from "./lib/crashOverlay";
import ErrorBoundary from "./components/ErrorBoundary";

installCrashOverlay();

function showBootError(err: unknown) {
  const msg = err instanceof Error ? `${err.message}\n\n${err.stack ?? ""}` : String(err);

  const el = document.createElement("div");
  el.style.position = "fixed";
  el.style.inset = "0";
  el.style.background = "#fff";
  el.style.color = "#111";
  el.style.padding = "16px";
  el.style.fontFamily = "monospace";
  el.style.whiteSpace = "pre-wrap";
  el.style.overflow = "auto";
  el.innerText =
    "Forkcast POS failed to start.\n\n" +
    msg +
    "\n\nUserAgent:\n" +
    navigator.userAgent;

  document.body.innerHTML = "";
  document.body.appendChild(el);
}

window.addEventListener("error", (e) => {
  showBootError((e as any).error ?? (e as any).message ?? e);
});

window.addEventListener("unhandledrejection", (e) => {
  showBootError((e as PromiseRejectionEvent).reason);
});

// PWA registration only when enabled.
// IMPORTANT: The @vite-ignore prevents build-time resolution when the PWA plugin is disabled.
(async () => {
  const pwaDisabled =
    (import.meta as any).env?.VITE_DISABLE_PWA === true ||
    String((import.meta as any).env?.VITE_DISABLE_PWA ?? "") === "1" ||
    String((import.meta as any).env?.VITE_DISABLE_PWA ?? "").toLowerCase() === "true";

  if (!import.meta.env.PROD || pwaDisabled) return;

  try {
    const mod = await import(/* @vite-ignore */ "virtual:pwa-register");
    if (mod?.registerSW) mod.registerSW({ immediate: true });
  } catch {
    // ignore
  }
})();

try {
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Missing #root element in index.html");

  createRoot(rootEl).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
} catch (err) {
  showCrashOverlay("Boot crash", err);
}
